/*
	Author : Sohan Kumar Dash
    Project : Pearlgreen
    Date : 17-04-2019
*/

//@module Favorites
define(
	'Favorites.Items.View'
,	[
		'favorites_items.tpl'
	,	'Product.Model'
	,	'ProductViews.Price.View'
	,	'Backbone'
	,	'Backbone.CompositeView'
	,	'jQuery'
	,	'underscore'
	,	'Utils'
	,	'Tracker'
	]
,	function (
		favorites_items_tpl
	,	ProductModel
	,	ProductViewsPriceView
	,	Backbone
	,	BackboneCompositeView
	,	jQuery
	,	_
	,	Utils
	,	Tracker
	)
{
	'use strict';

	//@module Favorites.Items.View @extends Backbone.View
	return Backbone.View.extend({

		template: favorites_items_tpl

	,	events: {
			'change [data-attr="unitstype"]': 'changeRate'
		}

	,	initialize: function()
		{
			BackboneCompositeView.add(this);
		}

	,	childViews:
		{
			'Favorites.Price.View': function()
			{
				return new ProductViewsPriceView({
					model: this.model.get('item')
				,	origin: "Favorites"
				});
			}
		}

	,	changeRate: function(e)
		{
			if(this.model.get('item').get('unitsType') && this.model.get('item').get('unitsType').length)
			{	
				var value = jQuery(e.target).val()
				,	unittype = _.find(this.model.get('item').get('unitsType'), function(unit){ return unit.id == value;})
				,	cRate = unittype ? unittype.convertionRate : ""
				,	saleUnitObj = _.findWhere(this.model.get('item').get('unitsType'), {saleUnit: true});
				
				if(cRate)
				{
					//var newPrice = parseInt(cRate) * this.model.getPrice().price;
					var newPrice = (this.model.getPrice().price / saleUnitObj.convertionRate) * cRate;
					this.model.get('item').set('customprice',newPrice);
				}
			}
		}

	,	changeRateString: function(e)
		{
			var value = jQuery(e.target).val()
			,	element = jQuery(e.target).parent().siblings().find('.ratestring');
			jQuery(element).toggleClass('hide');
		}

	,	computeRateString: function()
		{
			var existingUnitType = this.model.get('item').get('unitsType') ||  [];
			var rateStringArr = [];
			for (var e = 0; e < existingUnitType.length; e++)
			{
				var conv = existingUnitType[e].convertionRate;
				var rate = this.model.get('item').get('onlinecustomerprice_detail').onlinecustomerprice;
				var newRate = parseFloat(conv) * parseFloat(rate);
				newRate=Utils.formatCurrency(newRate);
				var obj = {};
				obj.id = existingUnitType[e].id;
				obj.isSelected = existingUnitType[e].baseUnit;
				obj.rateString = existingUnitType[e].pcs+'/'+existingUnitType[e].abbrevation+' at '+newRate;
				rateStringArr.push(obj);
			}
			return rateStringArr;
		}
		
		// @method getContext @return Favorites.Items.View.Context
	,	getContext: function()
		{
			var thumbnailObj = this.model.get('item').get('itemimages_detail')
			,	thumbnail= {} 
			,	self = this
			,	rateStringArr;
			var thumbnailArr = this.model.getImages();
				thumbnail = thumbnailArr[0];
			var sds_pdfUrl = this.model.get('item').get('custitem_appf_sds_pdf_file_name');
			
		/*	if(_.isEmpty(this.model.get('item').get('itemimages_detail')))
			{
				thumbnail.url = _.getAbsoluteUrl('img/no_image_available.jpeg');
			}
			else
			{
				if(thumbnailObj.urls.length)
				{
						thumbnail.url = thumbnailObj.urls[0].url;
						thumbnail.altimagetext = thumbnailObj.urls[0].altimagetext;
				}
				else
				{
					thumbnail.url = _.getAbsoluteUrl('img/no_image_available.jpeg');
				}
			}
			*/

			if(this.model.get('item').get('unitsType') && this.model.get('item').get('unitsType').length)
			{	
				_.each(this.model.get('item').get('unitsType'), function(unit){

					var optionModel = self.model.get('options').find(function(option){
						return option.get('cartOptionId') == 'custcol_appf_custom_uom_label_website';
					});
					if( optionModel.get('value') && optionModel.get('value').label && unit.name == optionModel.get('value').label)
					{
						unit.isSelected = true;
					}
				});
			}

			rateStringArr = this.computeRateString();
					
			return {
				// @class Favorites.Items.View.Context
				name: this.model.get('item').get('storedisplayname2')
			
			,	internalid: this.model.get('item').get('internalid')

			,	price_formatted: this.model.get('item').get('pricelevel1_formatted')

			,	url: this.model.get('item').get('urlcomponent') ? this.model.get('item').get('urlcomponent')  : '/product/'+this.model.get('item').get('internalid')
			
				//@property {String} unitType
			,	unitsType: this.model.get('item').get('unitsType')

			,	thumbnail: thumbnail

			,	listId: this.model.get('internalid')

			,	quantity: this.model.get('quantity')

			,	createdDate: this.model.get('createddate')
			
			,	storeDescription: (this.model.get('storedescription'))?this.model.get('storedescription'): ''

			,	rateStringArr: rateStringArr || []
			
			,	hasSDSheet: (sds_pdfUrl != null && sds_pdfUrl != '')? true:false
			
			,	SDSSheet: sds_pdfUrl
			
			,	itemid: this.model.get('item').get('itemid')
			
			,	uomExists:(this.model.get('item').get('unitsType') && this.model.get('item').get('unitsType').length > 0)?true:false
			
			,	isOutOfStock: this.model.get('item').get('showoutofstockmessage')
			};
		}

	});



});

